import { render, staticRenderFns } from "./Confirm-data.vue?vue&type=template&id=0061a7f0"
import script from "./Confirm-data.vue?vue&type=script&lang=js"
export * from "./Confirm-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports